module.exports = __webpack_public_path__ + "img/pdfImage.fd17fc0f.png";